import React, { useCallback } from "react";
import { GlobalStore } from "../../../store/global/GlobalStore";
import clsx from "clsx";
import {
  WalletContentDisplayLocations,
  WalletContentDisplayLocationsProps,
} from "./ConnectedWalletButton";
import { formatAddress } from "utils/walletUtils";
import { Address } from "viem";

interface WalletAddressLabelProps extends WalletContentDisplayLocationsProps {
  isVisible?: boolean;
}

export const WalletAddressLabel: React.FC<WalletAddressLabelProps> = props => {
  const address = GlobalStore.useState(s => s.address);
  const ensName = GlobalStore.useState(s => s.ensName);
  const theme = GlobalStore.useState(s => s.theme);

  const ADDRESS_STYLES: Record<
    WalletContentDisplayLocations,
    Record<string, React.CSSProperties>
  > = {
    [WalletContentDisplayLocations.Sidenav]: {
      wrapper: {},
      span: { fontSize: "16px", lineHeight: "120%", fontWeight: "500" },
    },
    [WalletContentDisplayLocations.Header]: { wrapper: {}, span: {} },
    [WalletContentDisplayLocations.WalletView]: { wrapper: {}, span: {} },
    [WalletContentDisplayLocations.NavbarV2]: {
      wrapper: {},
      span: {
        color: theme.theme[1700],
        fontSize: theme.fontSize["4"],
        lineHeight: theme.lineHeights["4"],
      },
    },
    [WalletContentDisplayLocations.NavbarV2Mobile]: {
      wrapper: {},
      span: {
        color: theme.font.primary.default,
        lineHeight: theme.lineHeights[4],
        fontSize: theme.fontSize[4],
        fontWeight: theme.fontWeights["work-sans-0"],
      },
    },
  };

  const getAddressLabel = useCallback((address: Address, ensName: string): string => {
    if (ensName) {
      return ensName;
    } else if (address) {
      return formatAddress(address);
    }
    return "";
  }, []);

  if (props.isVisible === false) {
    return null;
  }

  if (address == null) {
    return null;
  }

  return (
    <span
      style={ADDRESS_STYLES[props.displayLocation].span}
      className={clsx({ "address-text": true })}
      data-testid="wallet-address-label"
    >
      {getAddressLabel(address as Address, ensName)}
    </span>
  );
};
